import {
  IToggleSubscribeUserProps,
  followUser,
  getOtherUserData,
  toggleSubscribeUser,
  unfollowUser,
} from 'APIs/UserDataApi';
import { db } from 'app/firebase';
import { socket } from 'app/socket';
import { store } from 'app/store';
import { ACCESS_TOKEN } from 'constant';
import {
  addProgress,
  addSubscribedTo,
  removeTransaction,
  setWallet,
  updateFollowing,
} from 'features/auth/authSlice';
import { addCommentState } from 'features/auth/nftSlice';
import { addCommentState as addCommentStateOtr } from 'features/auth/otrSlice';
import {
  Timestamp,
  doc,
  serverTimestamp,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import Backstage from 'interfaces/Backstage.interface';
import BackstageComment, {
  IFormData,
} from 'interfaces/BackstageComment.interface';
import NftData from 'interfaces/NftData.interface';
import {
  CreateNotification,
  NotificationType,
} from 'interfaces/Notification.interface';
import { OtrData } from 'interfaces/OtrData.interface';
import { UserData } from 'interfaces/UserData.interface';
import { IAuthState } from 'interfaces/auth.interfaces';
import { SetStateAction } from 'react';
import { Crop } from 'react-image-crop';
import { Dispatch } from 'redux';
import { Socket } from 'socket.io-client';
import { getRef } from 'utils/Firebase.util';
import { checkStatus, sendEther } from 'utils/sendEther';
import { v4 } from 'uuid';
import { apiInstance, updateUser } from './AuthApi';
import { lockBackstage, patchBackstage } from './BackstageApi';
import {
  BackstageCommenDto,
  CommentType,
  postBackstageComment,
} from './BackstageCommentApi';
import { getUsdEthRates, updateTransactionProcessing } from './transactionApi';
import Torus from '@toruslabs/torus-embed';
import { VideoUrls } from 'utils/Fileupload.utils';
export const torus = new Torus({});

export const initializeTorus = async () => {
  await torus.init({
    enableLogging: false,
    whiteLabel: {
      theme: {
        isDark: true,
        colors: {
          torusBrand1: '#282c34',
        },
      },
      logoDark: 'https://tkey.surge.sh/images/Device.svg', // Dark logo for light background
      logoLight: 'https://tkey.surge.sh/images/Device.svg', // Light logo for dark background
      topupHide: false,
      featuredBillboardHide: true,
      disclaimerHide: true,
      defaultLanguage: 'en',
    },
    showTorusButton: false,
  });
};

export const uploadFile = async (
  data: FormData,
  setProgress?: SetStateAction<any>,
  watermark?: boolean,
  nftId?: number,
  backstageWatermark?: boolean
): Promise<string> => {
  return await apiInstance
    .post(
      `${'file-upload'}${
        watermark ? '?watermark=true' : '?watermark=false'
      }&avatar=false&id=${nftId}&${
        backstageWatermark
          ? 'backstageWatermark=true'
          : 'backstageWatermark=false'
      }`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        onUploadProgress: progressEvent => {
          const { loaded, total } = progressEvent;
          if (total && loaded) {
            const percent = Math.round((loaded * 100) / total);
            setProgress(percent);
            store.dispatch(addProgress(percent));
          }
        },
      }
    )
    .then(function(response) {
      //handle success
      return response.data;
    })
    .catch(function(error) {
      //handle error
      console.log(error);
    });
};

export const uploadNftFile = async (
  data: FormData,
  setProgress?: SetStateAction<any>,
  watermark?: boolean,
  nftId?: number,
  backstageWatermark?: boolean
): Promise<VideoUrls> => {
  return await apiInstance
    .post(
      `${'file-upload/separate'}${
        watermark ? '?watermark=true' : '?watermark=false'
      }&avatar=false&id=${nftId}&${
        backstageWatermark
          ? 'backstageWatermark=true'
          : 'backstageWatermark=false'
      }`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        onUploadProgress: progressEvent => {
          const { loaded, total } = progressEvent;
          if (loaded && total) {
            const percent = Math.round((loaded * 100) / total);
            setProgress(percent);
            store.dispatch(addProgress(percent));
          }
        },
      }
    )
    .then(function(response) {
      //handle success
      return response.data;
    })
    .catch(function(error) {
      //handle error
      console.log(error);
    });
};

export const uploadAvatar = async (data: FormData): Promise<string> => {
  return await apiInstance
    .post(
      `file-upload?avatar=true&watermark=false&backstageWatermark=false&id=undefined`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
      }
    )
    .then(function(response) {
      //handle success
      return response.data;
    })
    .catch(function(error) {
      //handle error
      console.log(error);
    });
};

interface IFollowUser {
  authState: IAuthState;
  data: UserData;
  following: boolean;
  setFollowing: SetStateAction<any>;
  dispatch: Dispatch;
}

export const handleFollowing = async ({
  authState,
  data,
  following,
  setFollowing,
  dispatch,
}: IFollowUser) => {
  if (authState.id && authState.username && data.id) {
    try {
      const user = await getOtherUserData(authState.username);
      if (!following) {
        try {
          setFollowing(true);
          const res = await followUser({
            followerId: authState.id,
            followingId: data.id,
          });
          if (res && user) {
            dispatch(
              updateFollowing({
                type: 'follow',
                authData: user,
                userData: data,
              })
            );
          }

          if (socket && authState.id && data.id) {
            const followNotification: CreateNotification = {
              fromId: authState.id,
              toId: data.id,
              notificationType: NotificationType.FOLLOW,
            };
            socket.emit('notification', followNotification);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          setFollowing(false);
          const res = await unfollowUser({
            followerId: authState.id,
            followingId: data.id,
          });
          if (res && user) {
            dispatch(
              updateFollowing({
                type: 'unfollow',
                authData: user,
                userData: data,
              })
            );
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
};

export const handleSubmitComment = async (
  formData: IFormData,
  type: CommentType,
  setLoading: SetStateAction<any>,
  setFormData: SetStateAction<any>,
  postId: string,
  dispatch: Dispatch,
  senderId: number,
  ownerId?: number,
  socket?: Socket,
  item?: NftData | OtrData,
  addComment?: (comment: BackstageComment, id: string) => void,
  parentCommentId?: string
) => {
  const data: BackstageCommenDto = {
    postId: postId,
    parentId: parentCommentId,
    content: formData.content,
    type,
  };

  if (socket) {
    setLoading(true);
    try {
      const res = await postBackstageComment(data);
      if (addComment && ownerId && !item) {
        addComment(res, res.id);
        const commentNotificationBackstage: CreateNotification = {
          fromId: senderId,
          toId: ownerId,
          notificationType: NotificationType.COMMENT,
          backstageId: parseInt(postId),
        };
        ownerId && socket.emit('notification', commentNotificationBackstage);
      } else if (item) {
        if (type === CommentType.NFT) {
          addCommentNft(res, res.id, item, dispatch);
        } else if (type === CommentType.OTR) {
          addCommentOtr(res, res.id, item, dispatch);
        }
        if (ownerId && item.id) {
          const commentNotificationNft: CreateNotification = {
            fromId: senderId,
            toId: ownerId,
            notificationType: NotificationType.COMMENT,
            nftId: item.id,
          };
          ownerId && socket.emit('notification', commentNotificationNft);
        }
      }
      if (res) {
        setFormData({
          postId: postId,
          parentCommentId: parentCommentId,
          content: '',
          type,
        });
      }
    } catch (error) {
      console.log('something went wrong with comment');
    }

    setLoading(false);
  }
};

export const addCommentNft = async (
  comment: BackstageComment,
  id: string,
  item: NftData | OtrData,
  dispatch: Dispatch
) => {
  if (item && item.id) {
    const newComment: BackstageComment = {
      ...comment,
      id,
      createdDate: new Date().getTime(),
      updatedDate: new Date().getTime(),
    };
    if (comment.parent) {
      const parentIndex = item.comments.findIndex(item => {
        if (comment.parent) return item.id === comment.parent.id;
        else return false;
      });
      if (!item.comments[parentIndex].children) {
        dispatch(addCommentState({ nftId: item.id, index: parentIndex }));
      }
      dispatch(
        addCommentState({
          nftId: item.id,
          index: parentIndex,
          children: true,
          backstageComment: newComment,
        })
      );
    } else
      dispatch(
        addCommentState({
          nftId: item.id,
          backstageComment: newComment,
        })
      );
  }
};

export const addCommentOtr = async (
  comment: BackstageComment,
  id: string,
  item: OtrData | NftData,
  dispatch: Dispatch
) => {
  console.log(comment, id, item);
  if (item && item.id) {
    const newComment: BackstageComment = {
      ...comment,
      id,
      createdDate: new Date().getTime(),
      updatedDate: new Date().getTime(),
    };
    if (comment.parent) {
      const parentIndex = item.comments.findIndex(item => {
        if (comment.parent) return item.id === comment.parent.id;
        else return false;
      });
      if (!item.comments[parentIndex].children) {
        dispatch(addCommentStateOtr({ otrId: item.id, index: parentIndex }));
      }
      dispatch(
        addCommentStateOtr({
          otrId: item.id,
          index: parentIndex,
          children: true,
          backstageComment: newComment,
        })
      );
    } else
      dispatch(
        addCommentStateOtr({
          otrId: item.id,
          backstageComment: newComment,
        })
      );
  }
};

export const handleToggleSubscribe = async (
  authState: IAuthState,
  setError: SetStateAction<any>,
  setTransaction: SetStateAction<any>,
  setLoading: SetStateAction<any>,
  setIsSubscribed: SetStateAction<any>,
  dispatch: Dispatch,
  isPost: boolean,
  price?: string,
  user?: Partial<UserData>,
  post?: Backstage,
  msgId?: string,
  authId?: number,
  userId?: number
) => {
  if (authState.id && user && user?.id) {
    if (!authState.walletAddress)
      await handleConnectWallet(dispatch, authState.id);
    if (user.walletAddress && authState.walletAddress) {
      try {
        if (
          post &&
          post.splitWith &&
          post.splitWith.length > 0 &&
          post.splitPercent &&
          price
        ) {
          const usd = await getUsdEthRates();
          price = (parseInt(price) / usd.USD).toFixed(6);
          const userCredit = parseInt(
            ((post.splitPercent * +price) / 100).toFixed(6)
          );
          const myCredit = +price - userCredit;

          post.splitWith.forEach(async splitter => {
            if (price)
              await sendEther(
                `${userCredit}`,
                splitter.walletAddress,
                setError,
                setTransaction,
                setLoading,
                setIsSubscribed,
                `${authState.id}`,
                `${splitter.id}`,
                dispatch,
                isPost,
                price,
                post.id
              );
          });
          await sendEther(
            `${myCredit}`,
            user.walletAddress,
            setError,
            setTransaction,
            setLoading,
            setIsSubscribed,
            `${authState.id}`,
            `${user.id}`,
            dispatch,
            isPost,
            price,
            post.id
          );
        } else if (post && price) {
          await sendEther(
            price,
            user.walletAddress,
            setError,
            setTransaction,
            setLoading,
            setIsSubscribed,
            `${authState.id}`,
            `${user.id}`,
            dispatch,
            isPost,
            price,
            post.id
          );
        } else if (price) {
          await sendEther(
            price,
            user.walletAddress,
            setError,
            setTransaction,
            setLoading,
            setIsSubscribed,
            `${authState.id}`,
            `${user.id}`,
            dispatch,
            isPost,
            price,
            undefined,
            msgId,
            authId,
            userId
          );
          if (user.discountedSubscriptionPrice && !user.trialDuration) {
            if (user.numberOfSales && user.numberOfSales > 1) {
              await updateUser({
                id: user.id,
                numberOfSales: user.numberOfSales - 1,
              });
            } else {
              await updateUser({
                id: user.id,
                discountedSubscriptionPrice: null,
                numberOfSales: 0,
              });
            }
          }
        }
      } catch (error) {
        setIsSubscribed(false);
        setTransaction(false);
      }
    }
  }
};

export const handleTrialSubscribe = async (
  authState: IAuthState,
  user: Partial<UserData>,
  setSubscribed: SetStateAction<any>,
  duration: Date
) => {
  if (authState.id && user.id) {
    const apiData: IToggleSubscribeUserProps = {
      fromUserId: authState.id,
      toUserId: user?.id,
      trialDuration: duration,
    };
    const res = await toggleSubscribeUser(apiData);
    if (res.status === 201 && user.numberOfSales) {
      await updateUser({ id: user.id, numberOfSales: user.numberOfSales - 1 });
      setSubscribed(true);
      if (socket && authState.id && user) {
        const subscribeNotification: CreateNotification = {
          fromId: authState.id,
          toId: user.id,
          notificationType: NotificationType.SUBSCRIPTION,
        };
        socket.emit('notification', subscribeNotification);
      }
    }
  }
};

export const checkSub = async (
  setSubLoading: SetStateAction<any>,
  authState: IAuthState,
  setSubscribed: SetStateAction<any>,
  setIsSubscribed: SetStateAction<any>,
  setTransaction: SetStateAction<any>,
  dispatch: Dispatch,
  user?: Partial<UserData>,
  isPost?: boolean,
  fetchData?: () => void,
  postData?: Backstage,
  isMsg?: boolean,
  setError?: SetStateAction<any>,
  setLoading?: SetStateAction<any>,
  authId?: number,
  userId?: number,
  msgId?: string
) => {
  setSubLoading(true);
  if (authState.id && user?.id && authState.transactionsReceived) {
    const apiData: IToggleSubscribeUserProps = {
      fromUserId: authState.id,
      toUserId: user?.id,
    };
    const transaction = authState.transactionsReceived.find(trx => {
      return (
        trx.from.id === authState.id &&
        trx.to.id === user.id &&
        postData?.id === (trx.postId === null ? undefined : trx.postId) &&
        trx.isProcessed === false
      );
    });
    if (
      transaction &&
      ((transaction.isPost && isPost) || (!transaction.isPost && !isPost))
    ) {
      const status = await checkStatus(transaction.hash, dispatch);
      if (status) {
        if (!isPost && !isMsg) {
          const res = await toggleSubscribeUser(apiData);

          if (res.status === 201) {
            dispatch(addSubscribedTo(res.data));
            fetchData && (await fetchData());
            setSubscribed(true);
            if (socket && authState.id && user) {
              const subscribeNotification: CreateNotification = {
                fromId: authState.id,
                toId: user.id,
                notificationType: NotificationType.SUBSCRIPTION,
              };
              socket.emit('notification', subscribeNotification);
            }
          }
          const updateTrx = await updateTransactionProcessing(
            true,
            transaction.hash
          );
          if (updateTrx.data)
            dispatch(
              removeTransaction({
                postId: postData?.id,
                hash: transaction.hash,
              })
            );
        } else if (postData && isPost) {
          await patchBackstage(postData.id, {
            userWithAccess: authState.id,
          });
          const updateTrx = await updateTransactionProcessing(
            true,
            transaction.hash
          );
          if (updateTrx.data)
            dispatch(
              removeTransaction({
                postId: postData?.id,
                hash: transaction.hash,
              })
            );
          setSubscribed(true);
          if (socket && authState.id && user) {
            if (postData.splitWith && postData.splitWith.length > 0) {
              postData.splitWith.forEach(splitUser => {
                if (authState.id) {
                  const contentNotification: CreateNotification = {
                    fromId: authState.id,
                    toId: splitUser.id,
                    notificationType: NotificationType.CONTENT,
                    backstageId: postData.id,
                  };
                  socket.emit('notification', contentNotification);
                }
              });
            } else {
              const contentNotification: CreateNotification = {
                fromId: authState.id,
                toId: user.id,
                notificationType: NotificationType.CONTENT,
                backstageId: postData.id,
              };
              socket.emit('notification', contentNotification);
            }
          }
        } else if (isMsg && authId && userId && msgId) {
          const dbRef = await getRef(authId, userId);
          if (dbRef) {
            await updateDoc(doc(db, 'chats', dbRef, 'messages', msgId), {
              isPending: false,
              isLocked: false,
            });
            const updateTrx = await updateTransactionProcessing(
              true,
              transaction.hash
            );
            if (updateTrx.data)
              dispatch(
                removeTransaction({
                  postId: postData?.id,
                  hash: transaction.hash,
                })
              );
            setSubscribed(true);
            if (socket && authState.id && user) {
              const contentNotification: CreateNotification = {
                fromId: authState.id,
                toId: user.id,
                notificationType: NotificationType.CONTENT,
              };
              socket.emit('notification', contentNotification);
            }
          }
        }
      } else {
        setIsSubscribed(true);
        setTransaction(true);
      }
    }
  }
  setSubLoading(false);
};

export const handleInviteCreatorForPost = async (
  authState: IAuthState,
  user: UserData,
  splitPercent: number,
  post: Partial<Backstage>,
  setSuccess: SetStateAction<any>,
  setError: SetStateAction<any>
) => {
  let dbRef: string | false | undefined;
  if (authState.id) {
    dbRef = await getRef(authState.id, user.id);
  }
  const updateFunction = async () => {
    const msgId = v4();
    if (dbRef)
      try {
        await setDoc(doc(db, 'chats', dbRef, 'messages', msgId), {
          uid: authState.id,
          type: 'collab',
          date: Timestamp.now(),
          id: msgId,
          post: {
            ...post,
            splitWith: [user],
            splitPercent,
            usersWithAccess: [user.id],
            creatorId: authState.id,
          },
          isClicked: false,
        });
      } catch (error) {
        throw error;
      }
  };
  if (dbRef) updateFunction();
  else {
    try {
      const msgId = v4();
      await setDoc(doc(db, 'chats', `${authState.id}-${user.id}`), {
        users: [authState.username, user.username],
        type: 'collab',
        date: serverTimestamp(),
      });
      await updateDoc(
        doc(db, 'chats', `${authState.id}-${user.id}`, 'messages', msgId),
        {
          type: 'collab',
          date: serverTimestamp(),
          uid: authState.id,
          id: msgId,
          post: { ...post, splitWith: [user], splitPercent },
          isClicked: false,
        }
      );
      setSuccess(true);
      setError(false);
    } catch (error) {
      console.log(error);
      setError(true);
      setSuccess(false);
    }
  }
};

export const updateMessageClicked = async (
  authId: number,
  userId: number,
  msgId: string
) => {
  try {
    const dbRef = await getRef(authId, userId);
    if (dbRef)
      await updateDoc(doc(db, 'chats', dbRef, 'messages', msgId), {
        isClicked: true,
      });
  } catch (error) {
    console.log(error);
  }
};

export const lockContentStateSetting = async (
  setLoading: SetStateAction<any>,
  selectedPosts: number[],
  price: string,
  setSelectedPosts: SetStateAction<any>,
  setSuccess: SetStateAction<any>,
  setError: SetStateAction<any>
) => {
  try {
    setLoading(true);
    await lockBackstage(selectedPosts, price);
    setLoading(false);
    setSelectedPosts([]);
    setSuccess(true);
  } catch (error) {
    console.log(error);
    setSuccess(false);
    setLoading(false);
  }
};

export async function getCroppedImg(
  image: File,
  crop: Crop,
  fileName: string,
  imgRef: React.RefObject<HTMLImageElement>
): Promise<File | null> {
  let output: File | null = null;
  const canvas = document.createElement('canvas');

  let img: HTMLImageElement;
  var fr = new FileReader();

  await new Promise((res, rej) => {
    fr.onload = async () => {
      await onFileLoad();
    };
    fr.readAsDataURL(image);

    async function onFileLoad() {
      img = new Image();
      img.onload = async () => {
        await onImageLoad();
      };
      img.src = String(fr.result);
    }
    async function onImageLoad() {
      if (imgRef.current) {
        const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
        const scaleY = imgRef.current.naturalHeight / imgRef.current.height;

        const ctx = canvas.getContext('2d');
        if (ctx) {
          const pixelRatio = window.devicePixelRatio;
          // const pixelRatio = 1

          canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
          canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

          ctx.scale(pixelRatio, pixelRatio);
          ctx.imageSmoothingQuality = 'high';

          const cropX = crop.x * scaleX;
          const cropY = crop.y * scaleY;

          const centerX = imgRef.current.naturalWidth / 2;
          const centerY = imgRef.current.naturalHeight / 2;

          ctx.save();

          ctx.translate(-cropX, -cropY);
          ctx.translate(centerX, centerY);
          ctx.scale(1, 1);
          ctx.translate(-centerX, -centerY);

          ctx.drawImage(
            imgRef.current,
            0,
            0,
            imgRef.current.naturalWidth,
            imgRef.current.naturalHeight,
            0,
            0,
            imgRef.current.naturalWidth,
            imgRef.current.naturalHeight
          );

          const blobFile = await new Promise<Blob>((resolve, reject) => {
            canvas.toBlob(blob => {
              if (!blob) {
                console.error('Canvas is empty');
                reject('Canvas is empty');
                return;
              }
              resolve(blob);
            }, 'image/jpeg');
          });

          output = new File([blobFile], fileName, {
            type: blobFile.type,
          });
          res(output);
        }
      }
    }
  });

  return output;
}

// onFileSave(){
//     const {blobFile} = this.state;
//     const newImage = new File([blobFile], blobFile.name, { type: blobFile.type });
//     let fd = new FormData();
//     fd.append(newImage.name, newImage);
//     saveImageToServer(fd);
// }

export async function updateImagePreview(
  crop: Crop,
  imgRef: React.RefObject<HTMLImageElement>,
  canvasRef: React.RefObject<HTMLCanvasElement>
): Promise<null> {
  if (imgRef.current && canvasRef.current) {
    const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
    const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
    const pixelRatio = window.devicePixelRatio;

    canvasRef.current.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvasRef.current.height = Math.floor(crop.height * scaleY * pixelRatio);

    const ctx = canvasRef.current.getContext('2d');

    if (ctx) {
      ctx.scale(pixelRatio, pixelRatio);
      ctx.imageSmoothingQuality = 'high';

      const cropX = crop.x * scaleX;
      const cropY = crop.y * scaleY;

      const centerX = imgRef.current.naturalWidth / 2;
      const centerY = imgRef.current.naturalHeight / 2;

      ctx.save();

      ctx.translate(-cropX, -cropY);
      ctx.translate(centerX, centerY);
      ctx.scale(1, 1);
      ctx.translate(-centerX, -centerY);

      ctx.drawImage(
        imgRef.current,
        0,
        0,
        imgRef.current.naturalWidth,
        imgRef.current.naturalHeight,
        0,
        0,
        imgRef.current.naturalWidth,
        imgRef.current.naturalHeight
      );
    }
  }
  return null;
}

// onFileSave(){
//     const {blobFile} = this.state;
//     const newImage = new File([blobFile], blobFile.name, { type: blobFile.type });
//     let fd = new FormData();
//     fd.append(newImage.name, newImage);
//     saveImageToServer(fd);
// }

export const handleConnectWallet = async (
  dispatch: Dispatch,
  userId: number
) => {
  if (window.ethereum) {
    window.ethereum
      .request({ method: 'eth_requestAccounts' })
      .then(async (res: any) => {
        // Return the address of the wallet
        if (res.length > 0) {
          dispatch(
            setWallet({
              walletAddress: res[0],
            })
          );
          await updateUser({ id: userId, walletAddress: res[0] });
        }
      });
  } else {
    alert('install metamask extension!!');
  }
};
